function pageHeader() {
    return {
    template :require('./bcb.pageHeader.html')
    };
};
export default pageHeader;



// WEBPACK FOOTER //
// ./src/login/header/bcb.pageHeader.js